import {Action, Actions, TabsHeader} from 'platform/components';
import {Heading, HStack, Scroll, Show, Space, useDevice} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {suffixTestId, TestIdProps} from 'shared/web';

export type PageTab = {
  id: string;
  title: string;
  href: string;
  content: ReactNode;
  isDisabled?: boolean;
} & TestIdProps;

export interface PageHeadingProps extends TestIdProps {
  title?: string;
  actions?: Action[];
  activeTabIndex?: number;
  tabs?: PageTab[];
  onTabChange?: (index: number) => void;
}

export function PageHeading(props: PageHeadingProps) {
  const device = useDevice();

  if (!props.title && !props.tabs?.length && !props.actions?.length) {
    return null;
  }

  const activeTabId = props.activeTabIndex?.toString();
  const handleOnChange = (val: string) => props.onTabChange?.(parseFloat(val));

  const tabs = (props.tabs ?? []).map((item, index) => ({...item, id: index.toString()}));

  const tabsHeader = (
    <TabsHeader
      tabs={tabs}
      activeTabId={activeTabId}
      onChange={handleOnChange}
      variant="condensed"
    />
  );

  return (
    <>
      <HStack spacing={4} justify="space-between" align="center">
        <Show when={props.title}>
          <Heading size={3} headingLevel={2} alternative data-testid={props['data-testid']}>
            {props.title}
          </Heading>
        </Show>
        <Show when={isNotNilOrEmpty(props.tabs)}>
          {device === 'mobile' ? (
            <Scroll auto hasHiddenScrollBars minWidth={0}>
              {tabsHeader}
            </Scroll>
          ) : (
            tabsHeader
          )}
        </Show>
        <Space fillAvailable />
        <Actions actions={props.actions} data-testid={suffixTestId('actions', props)} />
      </HStack>
      <Space vertical={4} />
    </>
  );
}
